export const HOSTING_GUIDE_QUERY_PARAM_KEY = 'hosting-guide'
